import { ErrorHandler, Injectable } from '@angular/core';
import { LogService } from './log.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private readonly logService: LogService) {}

  handleError(err: Error): void {
    this.logService.error(err.toString(), 'Error Handler Service');
  }
}
